import clsx from 'clsx';
import type { TooltipProps } from './TooltipProps';

export const infoIconStyles = ({
  variant,
  positioningInfoIcon,
}: {
  variant?: 'inline' | 'default';
  positioningInfoIcon: TooltipProps['positioning'];
}) =>
  clsx(
    'text-size-h4 flex flex-col p-0.5',
    variant === 'inline' ? 'relative' : 'absolute',
    positioningInfoIcon === 'left' && 'top-1/2 left-1',
    positioningInfoIcon === 'right' && 'top-1/2 right-1',
    positioningInfoIcon === 'top-start' && 'top-1 left-1',
    positioningInfoIcon === 'top-end' && 'top-1 right-1',
    positioningInfoIcon === 'bottom-start' && 'bottom-1 left-1',
    positioningInfoIcon === 'bottom-end' && 'right-1 bottom-1',
  );

export const wrapperStyles = ({
  variant,
  positioning,
}: {
  variant?: TooltipProps['variant'];
  positioning: TooltipProps['positioning'];
}) =>
  clsx(
    variant === 'inline' ? 'inline-flex' : 'flex',
    positioning &&
      ['top-start', 'bottom-start', 'left'].includes(positioning) &&
      'flex-row-reverse',
    'relative',
  );

export const infoIconButtonStyles =
  'bg-color-info-light border-color-info-dark hover:bg-color-info! data-[state=open]:shadow-lg h-3 min-h-3 w-3 rounded-full border-1 border-solid';

export const tooltipContainerStyles =
  'z-tooltip text-size-body-xs bg-color-text-light text-color-text-dark w-[18.75rem] max-w-[70vw] rounded p-1 font-normal shadow-lg data-[state=open]:motion-safe:animate-tooltip-fade-in data-[state=closed]:motion-safe:animate-tooltip-fade-out';

export const tooltipArrowStyles = 'fill-color-text-light';
